export const authenticationQuery = `query ($request: LoginRequest!) {
  authenticate(request:$request) {
    id,
    email,
    name,
    userType
  }
}`

export const registrationQuery = `mutation($input: Registration!) {
  createUser(registration:$input) {
    user {
    id
    email
    name
    userType 
    }
    errors {
      field
      message
    }
  } 
}`

export const resetPasswordQuery = `mutation($input: ResetPasswordRequest!) {
  resetPassword(request: $input) {
    user {
    id
    email
    name
    userType 
    }
    errors {
      field
      message
    }
  } 
}`

export const findUserQuery = `query ($criteria: UserCriteria!) {
  getUser(criteria: $criteria) {
        id
        email
        name
        userType
  } 
}`;


export const getCategoriesQuery = `query {
  getCategories{
    categoryId
    name
  }
}`;

